/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountTerminalApplicationsGetConfiguration } from "../../funcs/accountTerminalApplicationsGetConfiguration.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetTerminalConfigurationRequest$inboundSchema,
};

export const tool$accountTerminalApplicationsGetConfiguration: ToolDefinition<
  typeof args
> = {
  name: "account-terminal-applications-get-configuration",
  description:
    `Fetch the configuration for a given Terminal Application linked to a specific Account.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/terminal-configuration.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountTerminalApplicationsGetConfiguration(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
